<template>
  <div id="app">
    <div v-if="1 == 2">
      <van-nav-bar
        :title="title"
        :left-text="leftText"
        :right-text="rightText"
        :z-index="1000"
        :left-arrow="showNavbarLeft"
        fixed
        :class="{ 'van-nav-bar-blue': navbarColor === 'blue' }"
        @click-left="onClickLeft"
        @click-right="onClickRight"
      />
      <div style="height: 46px"></div>
    </div>

    <router-view />

    <div v-if="showTabbar">
      <van-tabbar v-model="tabbarActiveIndex" active-color="#810102">
        <van-tabbar-item @click="toHome">
          <template #icon="props">
            <i class="f_i jjnjmxer" :class="props.active ? 'act' : ''"></i>
          </template>
          首页
        </van-tabbar-item>
        <van-tabbar-item @click="toOrder">
          <template #icon="props">
            <i class="f_i jjnjmxer ab" :class="props.active ? 'act' : ''"></i>
          </template>
          订单
        </van-tabbar-item>
        <!-- <van-tabbar-item @click="toMemberCenter">
          <template #icon="props">
            <i class="f_i jjnjmxer ad" :class="props.active ? 'act' : ''"></i>
          </template>
          我的
        </van-tabbar-item> -->
      </van-tabbar>
      <div style="height: 50px"></div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import "@/utils/dayjs.js";
import { Input, Autocomplete } from "element-ui";

import {
  Tabbar,
  TabbarItem,
  NavBar,
  Dialog,
  Toast,
  Loading,
  Tab,
  Tabs,
  List,
  Row,
  Col,
  Cell,
  CellGroup,
  Button,
  Icon,
  ImagePreview,
  Panel,
  Popup,
  DatetimePicker,
  Field,
  RadioGroup,
  Radio,
  Collapse,
  CollapseItem,
  Uploader,
  Stepper,
  Picker,
  Area,
  NumberKeyboard,
  Search,
  ActionSheet,
  Tag,
  Switch,
  Checkbox,
  Calendar,
  Grid,
  GridItem,
  DropdownMenu,
  DropdownItem,
  Skeleton,
  Swipe,
  SwipeItem,
  Step,
  Steps
} from "vant";
import { mapState } from "vuex";
import appConsts from "./store/consts.js";
import "./assets/iconfont.css";
import "./assets/iconfont.css";

Vue.use(Tabbar)
  .use(TabbarItem)
  .use(NavBar)
  .use(Dialog)
  .use(Toast)
  .use(Loading)
  .use(Tab)
  .use(Tabs)
  .use(List)
  .use(Row)
  .use(Col)
  .use(Cell)
  .use(CellGroup)
  .use(Button)
  .use(Icon)
  .use(ImagePreview)
  .use(Panel)
  .use(Popup)
  .use(DatetimePicker)
  .use(Field)
  .use(RadioGroup)
  .use(Radio)
  .use(Collapse)
  .use(CollapseItem)
  .use(Uploader)
  .use(Stepper)
  .use(Picker)
  .use(Area)
  .use(NumberKeyboard)
  .use(Search)
  .use(ActionSheet)
  .use(Tag)
  .use(Switch)
  .use(Checkbox)
  .use(Calendar)
  .use(Grid)
  .use(GridItem)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(Input)
  .use(Autocomplete)
  .use(Skeleton)
  .use(Swipe)
  .use(SwipeItem)
  .use(Step)
  .use(Steps);

Toast.setDefaultOptions({
  duration: 2000
});

export default {
  data() {
    return {};
  },
  computed: {
    tabbarActiveIndex: {
      get() {
        return this.$store.state.tabbarActiveIndex;
      },
      set(value) {
        this.$store.commit(appConsts.activeTabbar, value);
      }
    },
    leftText() {
      return this.showNavbarLeft ? "返回" : "";
    },
    rightText() {
      return this.showNavbarRight ? "首页" : "";
    },
    ...mapState([
      "title",
      "showNavbar",
      "showNavbarLeft",
      "showNavbarRight",
      "navbarColor",
      "showTabbar"
    ]),
    ...mapState({
      member: (state) => state.memberModule.member
    })
  },
  methods: {
    toHome() {
      this.$router.push("/").catch(err => err);
    },
    toOrder() {
      this.$router.push("/order").catch(err => err);
    },
    toMemberCenter() {
      this.$router.push("/my").catch(err => err);
    },
    onClickLeft() {
      if (this.showNavbarLeft) {
        this.$router.go(-1);
      }
    },
    onClickRight() {
      if (this.showNavbarRight) {
        this.$router.push("/");
      }
    },
    onMemberCardClick() {
      if (this.member.hasElectronicMemberCard) {
        this.$router.push("/membercard");
      } else {
        this.$toast("此功能暂未开放");
      }
    }
  },
  mounted() {
    this.$store.commit(
      "setClientHeight",
      document.documentElement.clientHeight
    );
  }
};
</script>
